import React from 'react';
import { useOutletContext } from 'react-router-dom';

interface EditorContext {
  clientId: string;
  clientName?: string;
}

export const EditorProfile: React.FC = () => {
  const { clientName } = useOutletContext<EditorContext>();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow-xs border border-gray-200 p-8 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">{clientName}</h2>
        <p className="text-gray-600 mb-6">Client Profile</p>
        <div className="border-t border-gray-200 pt-6">
          <p className="text-gray-500 italic">
            Profile details, brand assets, and preferences coming soon...
          </p>
        </div>
      </div>
    </div>
  );
};
